
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E5E5E5","d":"M0 0h21v21H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M-1-1h23v23H-1z"}}),_c('circle',{attrs:{"cx":"10.5","cy":"10.5","r":"10","fill":"#C6C9CF"}}),_c('path',{attrs:{"d":"M7.13 7.925c.018-.87.319-1.568.902-2.092.584-.524 1.39-.786 2.42-.786.975 0 1.76.246 2.352.738.597.492.895 1.135.895 1.928 0 .506-.12.946-.362 1.32-.242.373-.608.703-1.1.99-.456.265-.764.502-.924.711-.159.21-.239.479-.239.807v.362H9.263l-.014-.376c-.046-.537.027-.977.219-1.319.196-.346.533-.66 1.011-.943.447-.265.75-.5.91-.704.16-.21.239-.472.239-.787a.965.965 0 00-.362-.779c-.237-.205-.55-.308-.937-.308-.392 0-.709.112-.95.335-.242.224-.374.525-.397.903H7.13zm4.013 6.973c-.22.204-.52.307-.903.307s-.686-.103-.909-.307c-.223-.21-.335-.495-.335-.855s.112-.645.335-.854c.223-.21.526-.315.91-.315.382 0 .683.105.902.314.223.21.334.495.334.855s-.111.645-.334.855z","fill":"#fff"}})])
          )
        }
      }
    